import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../environments/environment';
import {retry} from 'rxjs/internal/operators';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../services/state/states.service';
import {ModalService} from '../services/modal/modal.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private errorcount: number = 0;
  private maxRetry: number = 0;

  constructor(private toastr: ToastrService,
              private authenticationService: AuthenticationService,
              private translate: TranslateService,
              private modalService: ModalService,
              private stateService: StatesService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url === `oauth/v2/token`) {
      request = request.clone({
        url: environment.apiUrl + request.url,
        setParams: {
          locale: this.getLocal(),
          app: this.getApp()
        }
      });
    } else if (request.url.includes(`/i18n/`)) {
      request = request.clone({
        setParams: {
          locale: this.getLocal(),
          app: this.getApp()
        }
      });
    } else if (request.url.includes(`application.php`)) {
      request = request.clone({
        url: environment.apiUrl + request.url
      });
    } else {
      request = request.clone({
        url: environment.apiUrl + environment.guardedRoute + request.url,
        setParams: {
          locale: this.getLocal(),
          app: this.getApp()
        }
      });
    }

    return next.handle(request)
      .pipe(catchError(err => {
        this.errorcount += 1;
        let error = (err.error.message) || err.statusText;

        if (err.status === 401 || err.status === 403) {

          localStorage.removeItem(environment.levelLocalStored + this.authenticationService.getUserId());
          this.authenticationService.logout(true);
          this.modalService.dismissAllNgbModals();
        }
        if (this.errorcount > this.maxRetry) {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(error, this.translate.instant('ERROR') + ' : ', {enableHtml: true});
          }
          this.errorcount = 0;
        }

        return throwError(error);
      }))
      .pipe(retry(this.maxRetry)
      );
  }

  private getApp(): string {
    return this.authenticationService.userHasRoleOsmos() ? 'store' : 'works';
  }

  private getLocal() {
    return this.stateService.stateLanguage;
  }
}
